// extracted by mini-css-extract-plugin
export var emailBlockLink = "_hf-0";